<template>
  <div>
    <div id="detail" class="grid-container full container">

      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell" v-if="isAuthenticated">
            <div v-if="isEditOrderTitleActive">
              <input v-model="remarksParsed" type="text" 
              placeholder="Enquiry title here"
              maxlength="150"
              :disabled="loading"
               />
            </div>

            <h3 v-if="remarksParsed.length > 0 && !isEditOrderTitleActive">
              Enquiry {{remarksParsed}} 
            </h3>
            <h3 v-if="remarksParsed.length === 0 && !isEditOrderTitleActive">
              Enquiry #{{order.serialNumber}}
            </h3>
            
            <button class="button clear small" style="padding-top:0;padding-left:0;padding-bottom:0;"
            @click="isEditOrderTitleActive=!isEditOrderTitleActive"
            :disabled="loading">
              {{isEditOrderTitleActive? 'Cancel': 'Edit Title'}}
            </button>

            <button v-if="isEditOrderTitleActive"
            class="button clear small" 
            style="padding:0;"
            @click="saveEnquiryTitle"
            :disabled="loading || remarksParsed.trim().length === 0">
              Save Title
            </button>


            <p>
              {{ items.length }} Item(s) in your enquiry list <i>{{ remarksParsed.length>0 ? '#' + order.serialNumber : ''}}</i>
            </p>
          </div>

          <div v-if="isAuthenticated" class="cell">
            <div class="callout primary" style="border: none;">
              <span class="font-bold">About Prices: </span>
              Above price will be double checked by ONEBUY sales.
            </div>
          </div>

          <div
            v-if="isAuthenticated"
            class="product-details product-detail-photos cell"
          >
            <div class="grid-x grid-padding-x">
              <div class="cell large-9">
                <div
                  class="details-header grid-x grid-padding-y text-uppercase"
                  style="border-bottom: 1px solid grey;"
                >
                  <div class="cell text medium-6">Product details</div>
                  <div class="cell text medium-2 text-center">Price(EXW)</div>
                  <div class="cell text medium-2 text-center">Quantity</div>
                  <div class="cell text medium-2 text-center">SubTotal</div>
                </div>

                <div
                  v-for="(item, index) in items"
                  :key="index"
                  class="details-description grid-x grid-padding-y"
                  style="border-bottom: 1px solid grey;"
                >
                  
                  <div class="cell medium-6">
                    <div class="grid-x">
                      <div class="cell auto">
                        <router-link
                          class="h6"
                          :to="{
                            name: 'product-detail',
                            params: {
                              catalog: item.product.categoryFk,
                              productId: item.product.id,
                            },
                          }"
                        >
                          <img
                            :src="baseUrl + item.product.imgPath"
                            width="110"
                            class=""
                          />
                        </router-link>
                      </div>
                      <div class="cell large-10 padding-left-1">
                        <router-link
                          class="h6"
                          style="font-weight: bold;"
                          :to="{
                            name: 'product-detail',
                            params: { productId: item.product.id },
                          }"
                        >
                          {{ item.product.nameInfo.contentData }}
                        </router-link>
                        <p>
                          {{ item.product.descriptionInfo.contentData }} /
                          {{ item.isStandard ? "S" : "C" }}
                        </p>

                         <!-- <button
                              class="button hollow radius secondary" style="margin-right: 1rem;"
                              @click="deleteItem(item)"
                              :disabled="loading" 
                            >
                            Remove
                          </button> -->
                        
                          <button v-show="item.isStandard===false && (item.remarks && item.remarks.trim().length>0)" 
                            class="button hollow radius" type="button" :data-toggle="'remarks_' + item.id"
                            
                            :disabled="loading"
                          >
                            Size Info
                          </button>
                          <div v-if="item.remarks && item.remarks.trim().length>0" 
                            class="dropdown-pane radius callout primary" data-position="top" data-alignment="left" 
                          :id="'remarks_' + item.id" 
                          data-dropdown
                          data-hover="true"
                          style="font-size: 0.75rem;"
                          >
                            {{ item.remarks ? JSON.parse(item.remarks) : ''}}
                          </div>
                        
                      </div>
                    </div>
                  </div>
                  <div class="cell medium-2 text-center">
                    {{ (item.product.marketPrice || 0).toFixed(2) }} USD
                  </div>
                  <div class="cell medium-2 text-center">
                    <div class=" text-center" style="margin:0 auto;">
                      {{item.count}}  <span>{{uomList[item.uoMFk]}}</span>
                      <!-- <product-counter
                        v-model="item.count"
                        :min="1"
                        :max="5000"
                        :disabled="true"
                      /> -->

                      <!-- <div class="product-quantity-info">
                        <div class="quantity-unit">
                          <span class="">
                            <select readonly="readonly" v-model="item.product.uomFk">
                              <option v-for="(item, index) in uomList" :key="index" :value="item.id">{{item.name}}</option>
                            </select>
                          </span>
                        </div>
                      </div> -->


                    </div>
                  </div>
                  <div class="cell medium-2 text-center">
                    {{ ( item.totalCost || 0).toFixed(2) }} USD
                  </div>
                </div>
              </div>

              <div class="cell large-3">

                <div
                  class="details-header grid-x grid-padding-y text-uppercase"
                  style="border-bottom: 1px solid grey;"
                >
                  <div class="cell text-center">Cart Totals</div>
                </div>

                <div class="cell">

                 <div class="grid-x grid-padding-x">
                    <div class="cell medium-6 padding-top-1">
                      SubTotal
                    </div>
                    <div class="cell medium-6 padding-top-1">
                      {{ total.toFixed(2) }} USD
                    </div>

                     <div class="cell medium-6 padding-top-1">
                      Shipping
                    </div>
                    <div class="cell medium-6 padding-top-1 product-quantity-info">
                      <div class="quantity-unit">
                        {{shippingFeeSelected.name}}
                      </div>
                    </div>

                    <div class="cell medium-6 padding-top-1">
                      Total
                    </div>
                    <div class="cell medium-6 padding-top-1">
                      <!-- {{ total.toFixed(2) }} USD -->
                       <span class="font-bold">To Quote</span>
                    </div>

                    <!-- <div class="cell padding-top-1">
                      <textarea style="min-height:90px;" readonly="readonly" placeholder="">
                      </textarea>
                    </div> -->
                    <div class="cell padding-top-1">
                      <div class="callout primary">
                        Comments: 
                        <p>{{order.comments? JSON.parse(order.comments): ''}}</p>
                      </div>
                    </div>

                    <div class="cell padding-top-1">
                      
                    </div>

                    <div class="cell">
                      
                    </div>

                  </div>

                </div>
                
              </div>
            </div>
          </div>

          <div v-if="!isAuthenticated" class="cell">
            <div class="grid-x grid-padding-x container">
              <div class="cell large-6 text-center">
                <h3 class="font-bold">
                  Got an account?
                </h3>
                <p class="padding-bottom-1">
                  We saved your cart to your account. <br />
                  Simply login to retreive your cart items.
                </p>
                <router-link
                  :to="{ name: 'login' }"
                  class="text-uppercase button radius large"
                >
                  Account login
                </router-link>
              </div>
              <div class="cell large-6 text-center">
                <h3 class="font-bold">
                  Guest Customer?
                </h3>
                <p class="padding-bottom-1">
                  Did you start shopping on a different device? <br />
                  Create an account to access your cart on all your devices.
                </p>
                <router-link
                  :to="{ name: 'register' }"
                  class="text-uppercase button radius secondary large"
                >
                  Create an account
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Needs to Login Or Register Message-->
    <div class="reveal" id="exampleModal1" data-reveal>
      <h1>Submit Almost Done</h1>
      <p class="lead">
        Your are not signed in yet.
      </p>
      <p>
        Please
        <router-link :to="{ name: 'login' }" style="" data-close>
          Sign In
        </router-link>
        Or
        <span>Or</span>
        <router-link :to="{ name: 'register' }" style="" data-close>
          Register
        </router-link>
      </p>
      <button
        class="close-button"
        data-close
        aria-label="Close modal"
        type="button"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <button
      ref="modal"
      class="button"
      data-open="exampleModal1"
      style="visibility:hidden;opacity:0;"
    ></button>

    <!--Space-->
    <div class="container"></div>
  </div>
</template>

<script>
    import uomDataService from "@/app/services/uom-main-service.js";
    import orderDataService from "@/store.order/services/main-service.js";
    import userInfoService from "@/app.user/services/main-service.js";
    import configService from "@/app/config-service.js";

    export default {
        name: "userOrderDetails",
        props: ["orderId"],
        data() {
            return {
                userInfo: {},

                order: {
                  remarks: ''
                },
                remarksParsed: '',

                loading: false,
                errored: false,

                uomList: {},
                items:[],
                shippingFeeList: [],

                isEditOrderTitleActive: false
            };
        },
        computed:{
            baseUrl(){
                return configService.baseUrl;
            },
            fullName() {
            return this.userInfo.lastName
                ? this.userInfo.lastName + " " + this.userInfo.firstName
                : null;
            },
            isAuthenticated() {
            //TODO-VICTOR: CHECK For token or key?
            return this.fullName !== null;
            },
            total(){
                var total = 0;
                this.items.forEach(function(item){
                    total+=item.totalCost;
                });
                return total;
            },
            shippingFeeSelected(){
              var idx = this.shippingFeeList.findIndex(e=>e.id=== this.order.shippingCode);
              return idx > -1 ? this.shippingFeeList[idx] : {};
            }
        },
        created() {
            this.setShippingFeeList();

            this.userInfo = userInfoService.getCurrentUserInfo();

            this.getOrder();
            this.showDetails(parseInt(this.orderId));
        },
        methods: {
          async getOrder(){
            try {
                  this.loading = true;

                  const {data} = await orderDataService.getById(parseInt(this.orderId));
                  this.order = data;

                  this.remarksParsed = this.order.userDefinedTitle ? JSON.parse(this.order.userDefinedTitle) : '';
                
              } catch (error) {
                  this.errored = true;
                  console.error(error);
              } finally {
                  this.loading = false;
              }
           
          },
          async showDetails(orderId){
              if(orderId){
                  try {
                      this.loading = true;

                        var promises = [
                        uomDataService.get(),
                        orderDataService.getOrderDetails(orderId)
                        ];

                      const res = await Promise.all(promises);
                      
                      res[0].data.forEach(uom=>{
                        this.uomList[uom.id] = uom.name;
                      })
                      
                      this.items = res[1].data;

                      //Refresh Fn
                      this.$nextTick(function(){
                        $(document).foundation();
                      })
                      
                  } catch (error) {
                      this.errored = true;
                      console.error(error);
                  } finally {
                      this.loading = false;
                  }
              }
          },

          async saveEnquiryTitle(){
            try {
                this.loading = true;

                this.order.userDefinedTitle = JSON.stringify(this.remarksParsed.trim());

                //const {data} = 
                await orderDataService.updateOrderTitle(parseInt(this.orderId), this.order.userDefinedTitle);
                //this.remarks = data;
                
            } catch (error) {
                this.errored = true;
                console.error(error);
            } finally {
                this.isEditOrderTitleActive=false;
                this.loading = false;
            }
              

            
          },
        setShippingFeeList(){
              this.shippingFeeList = [
                { id: "1", name: 'FOB fee', hint: ''},
                { id: "2", name: 'CIF fee', hint: ''},
                { id: "3", name: 'DDU', hint: 'please offer your delivery address'}
                ];
            },
        },
    };
</script>


<style lang="scss">
@import "./../../assets/sass/settings/settings";

.catalog-title::before {
  content: "";
}

img {
  max-width: 100%;
  width: auto \9;
  height: auto;
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

#owl-demo .item img {
  display: block;
  width: 100%;
  height: auto;
}

.btns {
  display: table;
  margin: 30px auto;
}

.customNextBtn,
.customPreviousBtn {
  float: right;
  background: #2d9070;
  color: #fff;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.small-photos {
  .cell {
    padding-bottom: 1rem;
  }
}

.product-details {
  .details-header {
    font-size: 13px;
  }
  .details-description {
    font-size: 13px;
    p {
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss" scoped>